// TODO: Need to detect id collisions?
// TODO: Need to strip special characters from model string?
export const generateId = (model: string) => `mun-form-id-${model}`;
